import Indicator from '../Indicator';

/** Comparative Relative Strength indicator */
export default class YieldSpreadIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {Object} - Default parameters object
	 * @property {String} id - Indicator ID
	 * @property {String} name - Indicator name
	 * @property {Object[]} inputs - Indicator inputs
	 * @property {Number} valueMultiplier - Indicator value multiplier. Used to
	 * normalize percent values depending on data - 1 or 100
	 */
	_getDefaultParams() {
		return {
			id: 'yieldspread',
			name: 'Yield Spread',
			description: 'The Yield Spread Indicator measures the difference in yields between two distinct debt instruments, typically bonds, highlighting potential economic trends or investor sentiment shifts in the bond market.',
			inputs: [
				{ name: 'comparisonsymbol', value: '' }
			],
			valueMultiplier: 1
		};
	}

	/** @param {Object} data - Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
